import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Home from "./pages/Home";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import About from "./pages/About";
import AdminMessages from "./pages/AdminMessages";


function App() {
  const { i18n } = useTranslation();

  // whenever the language changes, flip the whole document's direction
  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      <Routes>

        {/* HOME PAGE */}
        <Route path="/" element={<Home />} />

        {/* ABOUT PAGE */}
        <Route path="/about" element={<About />} />

        {/* PRODUCTS PAGE */}
        <Route path="/products" element={<Products />} />

        {/* CONTACT PAGE */}
        <Route path="/contact" element={<Contact />} />

        <Route path="/eifjb-admin-834927" element={<AdminMessages />} />

        {/* OPTIONAL: fallback for wrong URLs */}
        <Route path="*" element={<Home />} />


      </Routes>
    </Router>
  );
}

export default App;
